import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=52554e0e&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=52554e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52554e0e",
  null
  
)

export default component.exports